import { createAuthClient } from "better-auth/react";
import { requireAuthIssuer } from "./build-env.ts";

export const issuer = requireAuthIssuer(import.meta.env.MODE, import.meta.env);
export const authApiBaseUrl = issuer;

export const authClient = createAuthClient({ baseURL: authApiBaseUrl });
